import React from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import FooterTail from './footer-tail';
import FooterHead from './footer-head';
import staticPath from 'util/misc/static-assets-path';
import { CHECKOUT, PRELAUNCH } from 'constants/page-names';

function MainFooter({ isMobile, templateConfig, isNative, isMainContentLoaderVisible, pageName }) {
    const tabIndex = pageName === CHECKOUT ? -1 : 0;
    return isMainContentLoaderVisible ? null : (
        <div className="main-footer skel--footer">
            {!isNative && ['default', 'lite'].includes(templateConfig.footer) && (
                <div className="grid--row">
                    <figure className="main-footer--illustration grid--col">
                        <img
                            className="main-footer--image"
                            src={staticPath('img/spacer/img-footer-on-white.png')}
                        />
                    </figure>
                </div>
            )}
            {!isMobile && !isNative && <FooterHead tabIndex={tabIndex} facet={templateConfig.footer}/>}
            <FooterTail tabIndex={tabIndex} hasAgbLink={pageName !== PRELAUNCH} hasAdditionalContent={!isNative}
                facet={templateConfig.footer}/>
        </div>
    );
}

MainFooter.propTypes = {
    isMainContentLoaderVisible: PropTypes.bool.isRequired,
    isNative: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    pageName: PropTypes.string,
    templateConfig: PropTypes.object.isRequired,
};

export default connect(
    reduxUtils.mapStateToProps({
        isMainContentLoaderVisible: 'main-content.isLoaderVisible',
        isMobile: 'viewport.isMobile',
        isNative: 'viewport.isNative',
        templateConfig: 'router.config',
        pageName: 'router.name',
    }),
)(MainFooter);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/main-footer/index.js